import {useEffect, useState} from "react";
import {useUserServerRoute} from "./useUserServerRoute";


export const useServerMenus = () => {

    const {serverMenus} = useUserServerRoute();
    const [userMenus, setUserMenus] = useState([]);


    useEffect(() => {

        const filterOnlyMenus = (menus) => {
            if (!menus) {
                return [];
            }


            return menus.map(x => ({...x})).filter(x => x.canShowInMenu).map((x) => {
                x.children = filterOnlyMenus(x.children);
                return x;
            });
        }


        const userMenu = filterOnlyMenus(serverMenus);
        setUserMenus(userMenu);
    }, [serverMenus]);


    return {
        userMenus
    }

}
